export default {
	"item.MallOrderConfirmationPageCouponRetentionPopUpWindowConfirmationButton": "商城订单确认页_优惠券挽留弹窗_确认按钮",
	"item.AcceptAndUse": "收下并使用",
	"item.PickUpFailed": "领取失败",
	"item.NoProductsSelected": "未选择商品",
	"item.NoAddressSelected": "未选择地址",
	"item.IfYouAreBuyingInInstallmentsPleaseSelectTheNumberOfInstallments": "如若分期购买请选择期数",
	"item.MarketplaceOrderConfirmationPagebottomButton": "商城订单确认页_底部按钮",
	"item.prompt": "提示",
	"item.UntieTheBindingForTheTimeBeing": "暂不解绑",
	"item.UnbindTheAccount": "解绑账号",
	"item.AccordingToTheRequirementsOfNationalPoliciesTheExpressMailSentToTaiwanNeedsToFillInTheCertificateNumberPleaseFillIn": "根据国家政策要求，发往台湾地区的快件需填写证件号码，请您补充填写",
	"item.Cancel": "取消",
	"item.GoReplenishment": "去补充",
	"item.SorryThePriceHasChanged": "抱歉，价格已发生变化!",
	"item.SorryFailedToCreateOrder": "抱歉，创建订单失败！",
	"item.RepeatPurchasePrompts": "重复购买提示",
	"item.ignore": "忽略",
	"item.ViewOrders": "查看订单",
	"item.WeChatCanEnterTheAccessAfterAuthorizationRequestAuthorization": "微信授权后可进入访问，请求授权中···",
	"item.OnTheMarketplaceOrderConfirmationPageClickOnAddress": "商城订单确认页_地址点击",
	"item.MarketplaceOrderConfirmationPagecouponClick": "商城订单确认页_优惠券点击",
	"item.Removed": "已下架",
	"item.SoldOut": "已售罄",
	"item.InsufficientGrowthBeans": "成长豆不足",
	"item.RedeemNow": "立即兑换",
	"item.SubmitYourOrder": "提交订单",
	"item.ParameterError": "参数错误!",
	"item.FirstInstalmentCredit": "首期优惠抵扣",
	"item.PleaseSelectAnAvailableCoupon": "请选择可用优惠券",
	"item.NoOffersAvailable": "无可用优惠",
	"item.ContinuousPackages": "连续包",
	"item.Every": "：每",
	"item.ChargesAreDeducted": "扣费",
	"item.head": "，首",
	"item.ImmediatelyReduced": "立减",
	"item.ThereIsNoDeliveryAddress": "暂无收货地址",
	"item.PleaseAddAShippingAddress": "请添加收货地址",
	"item.CallItOfficial": "叫叫官方",
	"item.Selected": "已选：",
	"item.DeliveryMethod": "配送方式",
	"item.ExpressDelivery": "快递配送",
	"item.Coupons": "优惠券",
	"item.use": "使用",
	"item.Deductions": "抵扣",
	"item.GrowBeans": "成长豆",
	"item.RemainingGrowingBeans": "剩余成长豆:",
	"item.TotalPayableForTheCurrentPeriod": "本期应付总额",
	"item.TheAmountOfTheItem": "商品金额",
	"item.freight": "运费",
	"item.total": "合计",
	"item.FlowerStaging": "花呗分期",
	"item.divide": "分",
	"item.timeLimit": "期",
	"item.Total¥": "总额¥",
	"item.HandlingFee¥": "手续费¥",
	"item.PleaseSelectTheStagingType": "请选择分期类型",
	"item.Total": "合计：",
	"item.InstallmentTotal": "分期总额：",
	"item.Premium": "手续费：",
	"item.PerIssue": "/每期",
	"item.GotIt": "知道了",
	"item.ToPayForThisOrderPleasePayInTheOrderLogisticsOfTheCallPublicAccount": "支付该订单请在【叫叫】公众号的订单物流中进行支付",
	"item.GrowingBeansUsageRules": "成长豆使用规则",
	"item.ProductDetailPageRetentionPopUpExposure": "商品详情页_挽留 弹窗曝光",
	"item.shoppingCentre": "商城",
	"item.ProductDetailPageRetainPopUpContentButtonClick": "商品详情页_挽留弹窗内容按钮点击",
	"item.other": "其他",
	"item.ClickTheBottomButtonOnTheProductDetailPageRetentionPopUpWindow": "商品详情页_挽留弹窗底部按钮点击",
	"item.abandon": "放弃"
}